import { isDevMode } from '@angular/core';

export function plutoDeployUrl(): string {
	return isDevMode() ? '' : '/Assets/pluto';
}
